function isWebdriverCookieSet() {
    return /(?:^|;\s*)webdriver=/.test(document.cookie);
}

export function returnFalseIfRunningViaAutomation() {
  const isInMemoryProvider =
    process.env.REACT_APP_FLAG_PROVIDER === "in-memory";
  const isAutomated = navigator?.webdriver || isWebdriverCookieSet();
  const isNavigatorWebdriver = navigator?.webdriver;

  if (isInMemoryProvider) {
    return isAutomated ? "false" : "true";
  } else {
    return isNavigatorWebdriver ? "false" : "true";
  }
}

export function isAutomateTest() {
  // Following envs are localhost or dev
  return (
    (process.env.REACT_APP_TEST_ENV === "true" ||
      process.env.NODE_ENV === "development") &&
    (navigator?.webdriver || isWebdriverCookieSet())
  );
}